import TicketQuery from '@/model/TicketParams'

export default {
  allTickets: ({ tickets }) => tickets,
  ticketsLoading: ({ loading }) => loading,
  postedTickets: ({ postedTickets }) => postedTickets,
  filter: ({ filters, contractMode }) => {
    if (filters.advancedSearch.active) {
      return filters.advancedSearch.query
    }
    const { inTransit, weighedIn, weighedOut, readyForPayment, posted, dateRange, internal, contract, tract, phrase, missingImages } = filters
    return new TicketQuery({
      inTransit: inTransit.active,
      weighedIn: weighedIn.active,
      weighedOut: weighedOut.active,
      readyForPayment: readyForPayment.active,
      posted: posted.active,
      dateRange: dateRange.active ? dateRange : undefined,
      limitInternal: internal.active,
      contractId: contract.contractId,
      tractId: tract.tractId,
      phrase: phrase.phrase,
      hasImages: missingImages.active ? false : undefined,
      contractMode: contractMode.value
    })
  },
  filters: ({ filters }) => filters,
  contractMode: ({ contractMode }) => contractMode
}
